import { render, staticRenderFns } from "./suggestion.vue?vue&type=template&id=36da8146"
import script from "./suggestion.vue?vue&type=script&lang=js"
export * from "./suggestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36da8146')) {
      api.createRecord('36da8146', component.options)
    } else {
      api.reload('36da8146', component.options)
    }
    module.hot.accept("./suggestion.vue?vue&type=template&id=36da8146", function () {
      api.rerender('36da8146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/sug/suggestion.vue"
export default component.exports